import { Link, Navigate, useSearchParams } from "react-router-dom";
import { SignIn, SignUp, Show } from "@clerk/react";
import { useMe } from "@/context/MeContext";

const Wrap = ({ children }) => <div className="flex min-h-[80vh] items-center justify-center px-4 py-16">{children}</div>;

export const SignInPage = () => <Wrap><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></Wrap>;
export const SignUpPage = () => {
  const [params] = useSearchParams();
  const media = params.get("rol") === "medio";
  return (
    <Wrap>
      <div className="flex flex-col items-center gap-6">
        {media && <p data-testid="signup-media-step" className="font-mono text-xs tracking-widest text-amber-500/90">PASO 1 DE 2 · CREA TU CUENTA</p>}
        <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" forceRedirectUrl={media ? "/bienvenida?rol=curator" : undefined} />
        <p data-testid="signup-legal-note" className="max-w-sm text-center text-xs text-slate-500">
          Al crear tu cuenta aceptas los <Link to="/terminos" className="text-[#FF7A45] underline">Términos de uso</Link> y la <Link to="/privacidad" className="text-[#FF7A45] underline">Política de privacidad</Link>.
        </p>
      </div>
    </Wrap>
  );
};

function SignedInHome({ children }) {
  const { me, loading } = useMe();
  if (!loading && me && !me.onboarded) return <Navigate to={`/bienvenida${window.location.search}`} replace />;
  return children;
}

export const HomeGate = ({ children }) => (
  <>
    <Show when="signed-in"><SignedInHome>{children}</SignedInHome></Show>
    <Show when="signed-out">{children}</Show>
  </>
);
